import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActionState, AssistantConfig, BaseComponentConfig, ComponentConfig, Relation, SelectedValue, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { options } from '../configoptions';

@Component({
  selector: 'ubs-store',
  template: `<ng-container *ngIf="hasValue">
    <ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
  </ng-container>`,
  styleUrls: ['./store.component.scss']
})
export class StoreComponent extends BaseComponentConfig implements OnInit {
  productStoreId: string;
  selectedValue: SelectedValue;
  hasValue = false;
  action: ActionState;

  @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()
  @Output() assistantConfig = new EventEmitter<AssistantConfig>()

  constructor(
    viewContainerService: ViewContainersService,
    menuService: NbMenuService,
    route: ActivatedRoute,
    router: Router,
    updateComponentStoreService: UpdateComponentStoreService,
    configurationService: ConfigurationService,
    private componentStore: UbsComponentStoreService) {
    super(viewContainerService, menuService, configurationService, route, router, updateComponentStoreService)

    this.route.paramMap.subscribe((params) => {
      if (params.get("productStoreId")) {
        console.log(params.get("productStoreId"));
        this.productStoreId = params.get("productStoreId");
        if (this.productStoreId != undefined) {
          this.route.data.subscribe(data => {
            console.log(data);
            if (data.event) {
              this.action = data.event;
              this.routerData = data;
            }
          })
          this.createMenuItems(this.productStoreId);
          this.setSelectedValue(this.productStoreId)
        }

      }
    })
  }

  ngOnInit(): void {
    console.log("What the fuck")

    options.defaultAction = this.action ? this.action : ActionState.EDIT;
    this.componentConfig = new ComponentConfig(options);
    if (this.productStoreId != undefined) {
      this.hasValue = true;
      if (this.action != null && this.action != undefined) {
        const paths = this.getPaths(options, this.action);
        let path;
        paths.forEach((p) => {
          if (this.router.url.includes(p)) {
            path = p;
          }
        });
        switch (this.action) {
          case ActionState.RELATE:
            const selectedRelation: Relation = this.setSelectedValueView(this.action, path, options);
            selectedRelation.listForm.findParameters = [];
            selectedRelation.listForm.findParameters.push({ "productId": this.productStoreId })
            break;
          case ActionState.MASTERDETAIL:
            options.selectedMasterDetails = this.setSelectedValueView(this.action, path, options);
            break;
          case ActionState.TASKSACTRSLT:
            options.selectedTask = this.setSelectedValueView(this.action, path, options);
            break;
          default:
            break;
        }
      }
    } else {
      this.action = ActionState.ADD;
    }
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    /**
     * Check if there is an assistantConfig form the component
     */
    if (this.componentConfig.assistant) {
      this.assistantConfig.emit(this.componentConfig.assistant)
    }
  }
  /**
   * Create context menu items for the entity
   * @param productStoreId
   */
  createMenuItems(productStoreId: string) {
    const menuItems: NbMenuItem[] = [
      {
        title: "Edit Store",
        link: "/admin/stores/store/" + productStoreId,
        icon: "edit-outline",
        data: {
          "event": "edit",
          "type": "EditProductStore",
          "label": "Edit Store " + productStoreId,
          "data": {
            formData: {
              formName: "EditProductStore",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          },
        }
      },
      {
        title: "Catalogs",
        link: "/admin/stores/store/" + productStoreId + "/catalogs",
        icon: "cube-outline",
        data: {
          "event": "relate",
          "type": "Catalogs",
          "label": "Catalogs for " + productStoreId,
          data: {
            formData: {
              formName: "UpdateProductStoreCatalog",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Payment Settings",
        link: "/admin/stores/store/" + productStoreId + "/paymentSettings",
        icon: "credit-card-outline",
        data: {
          "event": "relate",
          "type": "Payment Settings",
          "label": "Payment Settings for " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStorePaymentSettings",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Facilities",
        link: "/admin/stores/store/" + productStoreId + "/facilities",
        icon: "home-outline",
        data: {
          "event": "relate",
          "type": "Facilities",
          "label": "Facilities for " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreFacility",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Roles",
        link: "/admin/stores/store/" + productStoreId + "/roles",
        icon: "people-outline",
        data: {
          "event": "relate",
          "type": "Roles",
          "label": "Roles for " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreRole",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Store Promotions",
        link: "/admin/stores/store/" + productStoreId + "/promotions",
        icon: "gift-outline",
        data: {
          "event": "relate",
          "type": "Store Promotions",
          "label": "Store Promotions " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStorePromos",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Shipment Methods",
        link: "/admin/stores/store/" + productStoreId + "/shipmentMethods",
        icon: "car-outline",
        data: {
          "event": "relate",
          "type": "Shipment Methods",
          "label": "Shipment Methods " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreShipmentMeths",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Shipment Cost Estimates",
        link: "/admin/stores/store/" + productStoreId + "/shipmentCostEstimates",
        icon: "question-mark-outline",
        data: {
          "event": "relate",
          "type": "Shipment Cost Estimates",
          "label": "Shipment Cost Estimates " + productStoreId,
          data: {
            formData: {
              formName: "ListShipmentCostEstimates",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Financial Account Settings",
        link: "/admin/stores/store/" + productStoreId + "/financialAccountSettings",
        icon: "settings-outline",
        data: {
          "event": "relate",
          "type": "Financial Account Settings",
          "label": "Financial Account Settings " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreFinAccountSettings",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Store Email Settings",
        link: "/admin/stores/store/" + productStoreId + "/storeEmailSettings",
        icon: "at-outline",
        data: {
          "event": "relate",
          "type": "Store Email Settings",
          "label": "Store Email Settings " + productStoreId,
          data: {
            formData: {
              formName: "UpdateProductStoreEmail",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Store Surveys",
        link: "/admin/stores/store/" + productStoreId + "/storeSurveys",
        icon: "clipboard-outline",
        data: {
          "event": "relate",
          "type": "Store Surveys",
          "label": "Store Surveys " + productStoreId,
          data: {
            formData: {
              formName: "EditProductStoreSurveys",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Vendor Shipments",
        link: "/admin/stores/store/" + productStoreId + "/vendorShipments",
        icon: "settings-outline",
        data: {
          "event": "relate",
          "type": "Vendor Shipments",
          "label": "Vendor Shipments for " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreVendorShipments",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Vendor Payment Settings",
        link: "/admin/stores/store/" + productStoreId + "/vendorPaymentSettings",
        icon: "settings-outline",
        data: {
          "event": "relate",
          "type": "Vendor Payment Settings",
          "label": "Vendor Payment Settings for " + productStoreId,
          data: {
            formData: {
              formName: "ListProductStoreVendorPayments",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      },
      {
        title: "Web Sites",
        link: "/admin/stores/store/" + productStoreId + "/webSites",
        icon: "globe-outline",
        data: {
          "event": "relate",
          "type": "Web Sites",
          "label": "Web Sites for " + productStoreId,
          data: {
            formData: {
              formName: "EditProductStoreWebSites",
              formLocation: "component://kwikstore/widget/StoreForms.xml"
            },
            appContext: "catalog",
            parameters: { productStoreId: productStoreId }
          }
        }
      }
    ]
    setTimeout(() => {
      this.contextMenuItems.emit(menuItems)
    }, 1)
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

  setSelectedValue(productStoreId: string) {
    options.defaultAction = this.action ? this.action : ActionState.EDIT;
    if (this.action == ActionState.RELATE) {
      const relations: any[] = options.relations;
      console.log(relations);
      let position: number;
      relations.forEach((relation: Relation, i) => {
        if (relation.title == this.routerData["type"]) {
          this.selectedRelation = relation;
          position = i;
          console.log(this.selectedRelation, i)
        }
      })
      if (this.selectedRelation != undefined) {
        // Add the productId parameter value to the listForm Field
        this.selectedRelation.listForm.remoteFormData.parameters["productStoreId"] = productStoreId;
        // Move the selected relation to the top
        const reorderedRelations = this.reOrderRelations(relations, position);
        console.log(reorderedRelations);
        options.relations = reorderedRelations;
      }
    }


    const selectedValue: SelectedValue = {
      event: ActionState.EDIT,
      type: 'EditProductStore',
      label: "Edit Product Store",
      data: {
        formData: {
          formName: 'EditProductStore',
          formLocation: 'component://kwikstore/widget/StoreForms.xml',
          entityName: 'ProductStore',
        },
        parameters: { "productStoreId": productStoreId }
      }
    }
    setTimeout(() => {
      console.log(selectedValue)
      if (selectedValue) {
        console.log(selectedValue)
      } else {
        console.log("selectedValue is fokol");
      }

      // this.componentStore.updateSelectedValue(selectedValue);
      this.componentStore.updateSelectedValue({
        event: ActionState.EDIT,
        type: "EditProductStore",
        label: "Edit Product Store",
        data: {
          formData: {
            formName: 'EditProductStore',
            formLocation: 'component://kwikstore/widget/StoreForms.xml',
          },
          parameters: { "productStoreId": productStoreId }
        }
      });
      options.addForm["breadCrumbData"] = {
        "selectedValue": selectedValue
      }
      // options.addForm["breadCrumbData"]["selectedValue"] = selectedValue;
      this.componentConfig = new ComponentConfig(options);
      this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
      this.hasValue = true;
    }, 100)
  }


}
